'use client'

import AttachmentEditor from '@/utils/attachment/AttachmentEditor'
import { red } from '@ant-design/colors'
import { Card, Col, Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { SBDynamicFormInput } from './types'

const { Text } = Typography

const SBDynamicFormInputPhoto: SBDynamicFormInput = ({ ...rest }) => {
  const { t } = useTranslation('form')
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <AttachmentEditor
          label={t('questions.profilePicture')}
          formItem={rest}
          dragger={{ fileTypes: ['picture'] }}
        />
        <Card
          style={{
            borderColor: red[2],
            borderWidth: 1,
            borderStyle: 'solid',
            backgroundColor: red[0],
          }}
          styles={{ body: { padding: 16 } }}
        >
          <Text style={{ whiteSpace: 'pre-line' }}>
            {t('policies.pictureUpload')}
          </Text>
        </Card>
      </Col>
    </Row>
  )
}

export { SBDynamicFormInputPhoto }
